import DatabaseHandler from '@/libs/indexedDB/database-handler';

class SupervisorMW {
    constructor(VueInstance) {
        this.db = new DatabaseHandler();
        this.Instance = VueInstance;
    }

    GetTXes() {
        let self = this;


        return new Promise((resolve, reject) => {
            self.db.getAll('InspectionTX')
                .then(response => {
                    resolve(response);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        });

    }

    GetSingleTx(id) {
        let self = this;


        return new Promise((resolve, reject) => {
            self.db.getSingle('InspectionTX', {
                    CustomerInspectionItemID: id
                })
                .then(response => {
                    resolve(response);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        });

    }

    PostSingleJobTxToIndexedDB(SupervisorAllocatedInspectionID, SystemUserID, CustomerInspectionItemID, useFileInfo, ImageByte, Comments, Completed, date) {
        let self = this;

        return new Promise((resolve, reject) => {
            // create transaction on indexedDB
            let request = {
                SupervisorAllocatedInspectionID: SupervisorAllocatedInspectionID,
                SystemUserID: SystemUserID,
                CustomerInspectionItemID: CustomerInspectionItemID,
                FilePath: "",
                UseFileInfo: useFileInfo,
                Image: ImageByte,
                Completed: Completed,
                Comments: Comments,
                Date: date
            };

            self.db.add('InspectionTX', request)
                .then(inserted => {
                    console.log("[SINGLE TRANSACTION]", request);
                    resolve(inserted);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        });
    }

    PostSingleJobTxToServer() {
        let self = this;
        let JobTxesToPost = [];
        let AllocationsToPost = [];
        //var HeaderCount = 0;
        //var TXCount = 0;

        return new Promise((resolve, reject) => {
            self.db.getAll('InspectionTX')
                .then(response => {
                    console.log("[INDEXED DB RESPONSE]", response);
                    if (response != null || response != undefined && response.length > 0) {
                        response.forEach(el => {
                            var reader = new FileReader();
                            reader.onload = function () {
                                el.Image = Array.from(new Uint8Array(reader.result));
                                JobTxesToPost.push(el);
                            };

                            if (el.UseFileInfo == true) {
                                if (el.Image != null && el.Image != undefined) {
                                    reader.readAsArrayBuffer(el.Image);
                                } else {
                                    JobTxesToPost.push(el);
                                }
                            } else {
                                JobTxesToPost.push(el);
                            }

                        });

                        var Allocations = [];
                        self.db.getAll('AllocatedInspections')
                            .then(x => {
                                Allocations = x;
                                x.forEach(allocation => {
                                    JobTxesToPost.forEach(tx => {
                                        if (tx.SupervisorAllocatedInspectionID == allocation.AllocatedInspection.UID) {
                                            AllocationsToPost.push(allocation.AllocatedInspection);
                                        }
                                    });
                                });
                                console.log("[ALLOCATED INSPECTIONS TO POST]", AllocationsToPost);
                            })
                            .catch(xError => {
                                console.error(xError);
                            });
                        // post to server
                        console.log("[TO POST]", JobTxesToPost);

                        let OfflineRequestToPost = {
                            Allocations: AllocationsToPost,
                            InspectionTX: JobTxesToPost
                        };
                        console.log("[OFFLINE REQUEST TO POST]", OfflineRequestToPost);
                        self.Instance.post('Mobile/Supervisor/PostOfflineData', OfflineRequestToPost)
                            .then(result => {
                                console.log("[OFFLINE DATA POSTED TO SERVER]", result);
                                if (result.data == true) {
                                    // delete  txes from indexedDB
                                    console.log("[DELETE?????]")
                                    JobTxesToPost.forEach(el => {
                                        console.log("[JOB TO DELETE]", el);
                                        self.db.delete('InspectionTX', el.ID);
                                    });

                                    AllocationsToPost.forEach(alloc => {
                                        Allocations.forEach(all => {
                                            if (all.AllocatedInspection.UID == alloc.UID) {
                                                console.log("[ALLOC TO DELETE]", all);
                                                self.db.delete('AllocatedInspections', all.UID);
                                            }
                                        })
                                    });
                                }
                                resolve(JobTxesToPost);
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    PostUserData(UserID, CustomerList) {
        let self = this;

        return new Promise((resolve, reject) => {
            // create transaction on indexedDB
            let request = {
                UserID: UserID,
                CustomerList: CustomerList
            };

            self.db.add('UserData', request)
                .then(inserted => {
                    console.log("[INDEXED DB USER DATA]", request);
                    resolve(inserted);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        });
    }

    GetUserData() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.db.getAll('UserData')
                .then(response => {
                    resolve(response);
                })
                .catch(insertError => {
                    console.log('here', insertError)
                    reject(insertError);
                });
        });

    }

    DeleteUserData() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.db.getAll('UserData')
                .then(response => {
                    response.forEach(el => {
                        self.db.delete('UserData', el.ID);
                    });
                    resolve(response);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        })
    }

    AllocateInspection(UserID, Inspection) {
        let self = this;

        return new Promise((resolve, reject) => {
            // create transaction on indexedDB
            let request = {
                UserID: UserID,
                AllocatedInspection: Inspection
            };
            console.log("[MW-REQUEST]", request)
            self.db.add('AllocatedInspections', request)
                .then(inserted => {
                    console.log("[INDEXED DB ALLOCATED INSPECTIONS]", request);
                    resolve(inserted);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        });
    }

    GetAllocatedInspections() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.db.getAll('AllocatedInspections')
                .then(response => {
                    resolve(response);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        });

    }

    DeleteAllocatedInspections() {
        let self = this;

        return new Promise((resolve, reject) => {
            self.db.getAll('AllocatedInspections')
                .then(response => {
                    response.forEach(el => {
                        self.db.delete('AllocatedInspections', el.ID);
                    });
                    resolve(response);
                })
                .catch(insertError => {
                    reject(insertError);
                });
        })
    }
}

export default SupervisorMW;